/**
 * Amount.
 */

/**
 * Internal dependencies
 */
import Button from '../../../Button';

function Amount({
		value = [],
		setAmount = () => {},
		selected,
		disabled,
}) {
	return (
		<Button
			type="amount"
			onClick={setAmount}
			selected={selected}
			disabled={disabled}
		>
			{value}
		</Button>
	)
}

export default Amount;
